import React from 'react';
export function TestimonialsSection() {
  const testimonials = [{
    text: '"Hice el ritual de la carta quemada y algo se movió en mí que ninguna sesión de terapia había logrado. Sentí que algo cerró de verdad."',
    author: 'Valentina M.'
  }, {
    text: '"Llevaba 3 años hablando de mi ex en terapia. Con el ritual de corte de lazos sentí por primera vez que recuperé mi energía. El diario me ayudó a integrar todo."',
    author: 'Camila R.'
  }, {
    text: '"Soy psicóloga y uso estos rituales con mis pacientes. Es la herramienta que me faltaba para pasar de la palabra a la acción simbólica. Completamente recomendable."',
    author: 'Lic. Sofía B.'
  }, {
    text: '"Los rituales de emergencia me salvaron varias noches. Tener algo concreto para hacer en momentos de crisis fue invaluable."',
    author: 'Lucía P.'
  }, {
    text: '"No creía en estas cosas, pero el fundamento psicológico me dio confianza. Los ejercicios son simples pero muy profundos. El kit vale mucho más de lo que cuesta."',
    author: 'Martín G.'
  }];
  return <section className="s-dark fu" data-id="element-639">
      <div className="c" data-id="element-640">
        <span className="slabel" data-id="element-641">Testimonios verificados</span>
        <h2 className="stitle" data-id="element-642">
          Lo que dicen quienes
          <br data-id="element-643" />
          <em className="text-[var(--gold-l)]" data-id="element-644">ya lo hicieron.</em>
        </h2>
        <div className="div-line" data-id="element-645"></div>

        <div className="fu flex justify-center mt-6 md:mt-[40px]" data-id="element-646">
          <img src="https://cdn.magicpatterns.com/uploads/5LAPhgpPnefENonVDbxo8E/20260306_1916_Image_Generation_simple_compose_01kk2kg2npe3r9c227fabk5p5a.png" alt="Testimonios de compradores verificados" className="w-full max-w-[min(85vw,540px)] rounded-[20px] border border-[rgba(184,174,206,0.15)] shadow-[0_12px_40px_-10px_rgba(44,37,64,0.4)] mx-auto block" data-id="element-647" />
        </div>
      </div>
    </section>;
}